/**
 * Format a number to a string
 * @description Format a number to a string with commas and two decimal places
 * @param num number
 * @param locale string
 * @returns string
 */
export function formatNumber(num: number, locale: string = 'en-US'): string {
    // Check if the number is NaN or not a number
    if (isNaN(num) || typeof num !== 'number') {
        return '';
    }
    // Check if the number is an integer
    if (Number.isInteger(num)) {
        return new Intl.NumberFormat(locale, {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        }).format(num);
    }
    // Format the number with commas and two decimal places
    return new Intl.NumberFormat(locale, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }).format(num);
}

export function formatCurrency(
    num: number,
    locale: string = 'en-US',
    currency: string = 'USD',
): string {
    // Check if the number is NaN or not a number
    if (isNaN(num) || typeof num !== 'number') {
        return '';
    }
    // Format the number with commas and two decimal places
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }).format(num);
}

/**
 * Format a date to a string
 * @description Format a date to a string with the format 'MM/DD/YYYY HH:mm' (localized)
 * @param date string | Date
 * @param locale string
 * @returns string
 */
export function formatDate(date: string | Date, locale: string = 'en-US'): string {
    if (!date) return '';
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    };
    return new Date(date).toLocaleString(locale, options);
}
